import { driver } from 'driver.js';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const useClipsTour = () => {
  const driverRef = useRef<any>(null);
  const { t } = useTranslation();

  const initDriver = () => {
    driverRef.current = driver({
      showProgress: true,
      allowClose: true,
      doneBtnText: t('Finalizar'),
      nextBtnText: t('Siguiente'),
      prevBtnText: t('Anterior'),
      steps: [
        {
          element: '#clips-page',
          popover: {
            title: 'TODOS los clips!',
            description: 'Aquí veremos TODOS los clips creados',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#shorcut',
          popover: {
            title: 'Atajos de teclado',
            description: 'Dandole click a este icono puedes ver los atajos de teclado disponibles',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#parrilla-segments-filter',
          popover: {
            title: 'Filtros de clips',
            description: 'Aqui tienes todos los filtros disponibles para buscar los clips',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#parrilla-segments-search',
          popover: {
            title: 'Búsqueda de clips',
            description: 'Puedes buscar clips por nombre, fecha',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-fast-filters',
          popover: {
            title: 'Filtros rápidos',
            description: 'Estos son todos los filtros rápidos que puedes usar para buscar clips',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-column-filters',
          popover: {
            title: 'Filtros de columnas',
            description: 'Con estos botones puedes controlar la visibilidad de las columnas',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#clips-list',
          popover: {
            title: 'Lista de clips',
            description: 'Aquí verás la lista de clips que cumplen con los filtros aplicados',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#clip-detail-card',
          popover: {
            title: 'Detalle del  clip',
            description: 'Aquí verás el detalle del clip seleccionado',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#segments-toolkit',
          popover: {
            title: 'Toolkits disponibles',
            description:
              'En esta columna podras ver las toolkits disponibles para el clip seleccionado',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#help',
          popover: {
            title: 'Ayuda',
            description:
              'Para iniciar el tour de ayuda, haz click en este icono y sigue las instrucciones',
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    });
  };

  const startTour = () => {
    if (!driverRef.current) {
      initDriver();
    }
    driverRef.current.drive();
  };

  return { startTour };
};
